const GlobalVar = {
    // PRODUCTION env
    FRONTEND_URI: "https://tapchi.ut.edu.vn",
    BACKEND_URI: "https://tapchi.ut.edu.vn:5000",

    // DEVELOPMENT env
    // FRONTEND_URI: "http://localhost:3000",
    // BACKEND_URI: "http://localhost:5000",
};

export default GlobalVar;